import { ElementRef } from '@angular/core'
import * as d3 from 'd3'
import {
  ICoreConfig,
  ICoreMarginConfig,
  IDimensions,
  IInnerDimensions,
  ISvgScales,
  NodeSize,
  SVGComponents,
  TraitDotsType,
} from '../core/culture-index-chart.model'

export const calculateDimensions = (svgRef: ElementRef<SVGSVGElement>, margin: ICoreMarginConfig): IInnerDimensions & IDimensions => {
  const { clientWidth: width, clientHeight: height } = svgRef.nativeElement
  return {
    width,
    height,
    innerWidth: width - margin.left - margin.right,
    innerHeight: height - margin.top - margin.bottom,
  }
}

export const getScales = ({ innerHeight, innerWidth }: IInnerDimensions, { gridHeight, margin, gridWidth }: ICoreConfig): ISvgScales => {
  const xScale = d3
    .scaleLinear()
    .domain([0, gridWidth])
    .range([margin.left, margin.left + innerWidth])
  const yScale = d3
    .scaleLinear()
    .domain([0, gridHeight])
    .range([margin.top, margin.top + innerHeight])
  return { xScale, yScale }
}

export const getNodeRadius = (baseRadius: number, nodeSize: NodeSize): number => {
  switch (nodeSize) {
    case 'small':
      return baseRadius * 0.7
    case 'large':
      return baseRadius * 1.2
    default:
      return baseRadius
  }
}

export const easeLinearAnimation = d3.easeLinear

export function triangleSymbol(size?: number, arrowScale?: number) {
  return d3
    .symbol()
    .type(d3.symbolTriangle2)
    .size((size ?? 2) * (arrowScale ?? 0.5))
}

export const transitionOpacity = (selection: d3.Selection<any, any, any, any>, duration: number, delay: number = 0) => {
  selection.style('opacity', 0).transition().duration(duration).delay(delay).ease(easeLinearAnimation).style('opacity', 1)
}

export function getFontSize({ innerWidth }: Pick<IInnerDimensions, 'innerWidth'>) {
  if (innerWidth > 800) return 22
  if (innerWidth > 500) return 18
  if (innerWidth > 300) return 16
  return 12
}

export function getGroupClassNames(components: SVGComponents[], dotsType: TraitDotsType[]) {
  return dotsType.map(dt => components.map(c => `g.${dt}${c}`)).flat()
}

export function getOneOfDotsType(compare?: boolean) {
  if (compare) return TraitDotsType.COMPARE_DOTS
  return TraitDotsType.MAIN_DOTS
}
